import { render } from "./BasicLayout.vue?vue&type=template&id=56b40894&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=56b40894&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56b40894"

export default script